import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import Footur from '../components/footur';
import Header from '../components/Header';
import coverImage from '../assets/image/cover.png';

const Article = () => {
  return (
    <div className='flex flex-col min-h-screen'>
      {/* Header */}
      
      
    </div>
  );
};

export default Article;
